import { ConfirmModal } from 'shared/modals/confirmModal';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import intl from 'react-intl-universal';
import PropTypes from 'prop-types';

const propTypes = {
  isOpened: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

const SentIssueFailedModal = ({ isOpened, onConfirm }) => {
  return (
    <ConfirmModal
      isOpened={isOpened}
      title={intl.get('new_modal_new_issue_failed_message_1')}
      bodyText={intl.get('new_modal_new_issue_failed_message_2')}
      onConfirm={onConfirm}
      confirmButtonText={intl.get('new_modal_new_issue_failed_message_4')}>
      <MDBox data-testid="modal-child-box" sx={{ maxWidth: 'md' }}>
        <MDTypography variant="h6">
          {intl.get('new_modal_new_issue_failed_message_3')}
        </MDTypography>
      </MDBox>
    </ConfirmModal>
  );
};

SentIssueFailedModal.propTypes = propTypes;

export default SentIssueFailedModal;
